import { Stack, Typography } from '@mui/material';

import { CheckCircleIcon } from '@/components/icons/CheckCircleIcon';
import { CheckFilledIcon } from '@/components/icons/CheckFilledIcon';
import { COLORS } from '@/styles/tokens/colors';

interface RecommendedDocumentChipProps {
  label: string;
  /** Whether a document of this type has been uploaded. */
  isSatisfied: boolean;
}

/**
 * A single document-type chip in the "Recommended documents" panel. Shows a
 * filled green check once a matching document has been uploaded, otherwise an
 * empty circle.
 */
export function RecommendedDocumentChip({
  label,
  isSatisfied,
}: RecommendedDocumentChipProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        border: `1px solid ${COLORS.GRAY[200]}`,
        borderRadius: 1,
        bgcolor: COLORS.GRAY[50],
        px: 1,
        py: 1,
      }}
    >
      {isSatisfied ? (
        <CheckFilledIcon size={16} color={COLORS.FUNCTIONAL.SUCCESS[500]} />
      ) : (
        <CheckCircleIcon size={16} color={COLORS.GRAY[400]} />
      )}
      <Typography variant="body-xs">{label}</Typography>
    </Stack>
  );
}
